import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchFinishings() {
  try {
    const res = await apiAxios.get("/jobs/finishings");
    return res.data.data;
  } catch (e) {
    console.log(e);
  }
}

function useFinishingData() {
  const { user: userState } = useContext(LoginStateContext);

  return useQuery(["finishings"], fetchFinishings, {
    enabled: userState.isLoggedIn,
  });
}

export default useFinishingData;
